export default {
  locale: "nl",
  Table: {
    filterTitle: "Filteren",
    filterConfirm: "OK",
    filterReset: "Reset",
    selectAll: "Selecteer huidige pagina",
    selectInvert: "Deselecteer huidige pagina",
  },
  Modal: {
    okText: "OK",
    cancelText: "Annuleren",
    justOkText: "OK",
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Annuleren",
  },
  Transfer: {
    searchPlaceholder: "Zoeken",
    itemUnit: "item",
    itemsUnit: "items",
  },
  Upload: {
    uploading: "Uploaden...",
    removeFile: "Verwijder bestand",
    uploadError: "Fout tijdens uploaden",
    previewFile: "Bekijk bestand",
  },
  Empty: {
    description: "Geen gegevens",
  },
  Text: {
    edit: "Wijzigen",
    copy: "Kopiëren",
    copied: "Gekopieerd!",
    expand: "Uitklappen",
  },
};
//# sourceMappingURL=nl_NL.js.map
